"use strict";
'app public';

/** @module */
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.botDisplayNick = botDisplayNick;
exports.connectionInfoFromConfig = connectionInfoFromConfig;
exports.connectionToUri = connectionToUri;
exports.dateIso = dateIso;
exports.dedotObject = dedotObject;
exports.extractBuffers = extractBuffers;
exports.extractURL = extractURL;
exports.getDefaultConnection = getDefaultConnection;
exports.hasUnmatchedTrailingBracket = hasUnmatchedTrailingBracket;
exports.isBotNick = isBotNick;
exports.isServiceBot = isServiceBot;
exports.makePluginObject = makePluginObject;
exports.matchUri = matchUri;
exports.mentionsNick = mentionsNick;
exports.networkErrorMessage = networkErrorMessage;
exports.parseIntZero = parseIntZero;
exports.parseIrcUri = parseIrcUri;
exports.parsePresetServer = parsePresetServer;
exports.processNickRandomNumber = processNickRandomNumber;
exports.queryStringVal = queryStringVal;
exports.replaceObjectProps = replaceObjectProps;
exports.strCompare = strCompare;
exports.stripStyles = stripStyles;
var _lodash = _interopRequireDefault(require("lodash"));
var _vue = _interopRequireDefault(require("vue"));
var _strftime = _interopRequireDefault(require("strftime"));
var _PluginWrapper = _interopRequireDefault(require("@/components/utils/PluginWrapper"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _TextFormatting2 = require("./TextFormatting");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const strftimeUTC = _strftime.default.timezone('+0');
const styleStripRegexp = new RegExp(
// Decimal Colours
/(\x03(\u200B|[0-9]{1,2})(\u200B|,[0-9]{1,2})?|\x03)|/.source +
// Hex Colours
/(\x04(\u200B|[0-9a-fA-F]{6})(\u200B|,[0-9a-fA-F]{6})?|\x04)|/.source +
// Styles
/[\x02\x1d\x1f\x1e\x11\x16\x0f]/.source, 'g');

/**
 * Extract an array of buffers from a string, parsing multiple buffer names and channel keys
 * "#chan,#chan2" => 2 channels without a key
 * "#chan,#chan2 key" => 2 channels, the first having a key
 * "#chan,#chan2 key1,key2" => 2 channels, both having a key
 * "#chan,#chan2 ,key2" => 2 channels, the second having a key
 * @param {string} str List of buffer names and channel keys
 */
function extractBuffers(str) {
  let spaceIdx = str.indexOf(' ');
  if (spaceIdx === -1) spaceIdx = str.length;
  let bufferNames = str.substr(0, spaceIdx).split(',');
  let keys = str.substr(spaceIdx + 1).split(',');
  let buffers = [];
  bufferNames.forEach((bufferName, idx) => {
    // return if bufferName is empty
    if (!bufferName.trim()) {
      return;
    }
    buffers.push({
      name: bufferName,
      key: keys[idx] || ''
    });
  });
  return buffers;
}
function extractURL(str) {
  let matches = str.match(_TextFormatting2.urlRegex);
  return matches ? matches[0] : '';
}
function stripStyles(str) {
  return str.replace(styleStripRegexp, '');
}

// Pseudos des bots/services affichés comme « Robot » et jamais cliquables (pas de
// modal profil), que ce soit en nicklist ou dans les messages de salon.
const BOT_NICKS = ['chaat', 'partner', 'partners', 'robot'];

/**
 * Un pseudo correspond-il à un bot de service (Chaat / Partners / Robot) ?
 * @param {string} nick
 */
function isBotNick(nick) {
  return BOT_NICKS.includes((nick || '').toLowerCase());
}

/**
 * Nom d'affichage d'un pseudo : « Robot » pour les bots, sinon le pseudo tel quel.
 * @param {string} nick
 */
function botDisplayNick(nick) {
  return isBotNick(nick) ? 'Robot' : nick;
}

// Hosts des bots de service du réseau (ex. « Entre-Mecs » = service des salons) :
// leur pseudo varie (souvent = nom du salon) mais leur host est fixe.
const SERVICE_BOT_HOSTS = ['secu.chaat.fr', 'clara.chaat.fr', 'eva.chaat.fr'];

/**
 * Un utilisateur est-il un bot de service ? Reconnu par son HOST (secu/clara/eva)
 * OU par son pseudo (Chaat / Partners / Robot). À utiliser dès qu'on dispose de
 * l'objet user (nicklist, messages, profil) ; isBotNick ne couvre que le pseudo.
 * @param {Object} user
 */
function isServiceBot(user) {
  if (!user) {
    return false;
  }
  const host = (user.host || '').toLowerCase();
  return SERVICE_BOT_HOSTS.includes(host) || isBotNick(user.nick);
}

/**
 * Does a string mention a nickname?
 * @param {string} input The string to search within
 * @param {string} nick The nick to search for
 */
function mentionsNick(input, nick) {
  if (input.toLowerCase().indexOf(nick.toLowerCase()) === -1) {
    return false;
  }
  let punc = '\\s,.!:;+()\\[\\]?¿\\/<>@-';
  let escapedNick = _lodash.default.escapeRegExp(nick);
  let stylesStrippedInput = stripStyles(input);
  let r = new RegExp(`(^|[${punc}])${escapedNick}([${punc}]|$)`, 'i');
  return r.test(stylesStrippedInput);
}

/**
 * Get a query string value from the current URL
 * @param {string} _name The query string variable name
 * @param {string} _url The full URL to extract the variable from
 */
function queryStringVal(_name, _url) {
  // Le script de nettoyage d'URL (tête d'index.html) retire les params de la barre
  // d'adresse mais conserve la query d'entrée dans window.appEntryQuery. On la lit en
  // priorité (quand aucune URL explicite n'est fournie) pour que thème / go / nick /
  // ASL continuent de fonctionner après nettoyage ; sinon repli sur location.href.
  let url = _url || typeof window !== 'undefined' && window.appEntryQuery || window.location.href;
  let name = _lodash.default.escapeRegExp(_name);
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  let results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Convert a known error code to a human readable message
 * @param {string} err The error message from the network connection
 */
function networkErrorMessage(err) {
  const translationKey = err.replace(/^err_/, 'error_');
  const translation = TextFormatting.t(translationKey);
  if (translation === translationKey) {
    return TextFormatting.t('error_unknown');
  }
  return translation;
}

/**
 * Replace ? in nick with random number
 * @param {String} nick A users nick where ? needs replacing
 * @returns {String}
 */
function processNickRandomNumber(nick) {
  // Replace ? with a random number
  return (nick || 'app-n?').replace(/\?/g, () => Math.floor(Math.random() * 100).toString()).trim();
}

/**
 * Take a users connection object (usually from startupOptions) and normalise a connection
 * settings object. Parses websocket/direct/appServer/etc options and creates a single
 * object that App can consistently read from.
 * @param {Object} config User provided connection config object
 */
function connectionInfoFromConfig(config) {
  let connection = {
    tls: false,
    port: 0,
    hostname: '',
    direct: false,
    direct_path: ''
  };
  let wsUri = config.websocket ? matchUri(config.websocket) : null;
  if (wsUri) {
    connection.direct = true;
    connection.tls = ['wss', 'https', 'ircs'].indexOf(wsUri.protocol) > -1;
    connection.port = wsUri.port;
    connection.hostname = wsUri.hostname;
    connection.direct_path = wsUri.path;
    if (wsUri.search) {
      connection.direct_path += '?' + wsUri.search;
    }
  } else {
    connection.tls = config.tls;
    connection.port = config.port;
    connection.hostname = config.server;
    connection.direct = !!config.direct;
    connection.direct_path = config.direct_path || '';
  }
  return connection;
}
function matchUri(uri) {
  let reg = /(?:([a-z]+):\/\/)?([a-z.0-9-]+)(?::(?:(\+)?([0-9]+)))?(?:\/([^?]*))?(?:\?(.*))?/;
  /*
  0: "ws://hostname.com:6676/erferf?foo=val"
  1: "ws"
  2: "hostname.com"
  3: undefined
  4: "6676"
  5: "erferf"
  6: "foo=var"
  */
  let m = uri.match(reg);
  if (!m) {
    return null;
  }
  return {
    protocol: (m[1] || '').toLowerCase(),
    hostname: m[2] || '',
    port: parseIntZero(m[4] || ''),
    path: '/' + (m[5] || ''),
    search: m[6] || ''
  };
}

/**
 * Parse a connection string into an object
 * E.g. [ircs?://]irc.network.net:[+]6667/channel?nick=mynick;
 * Multiple connections may be given, separated by ;
 * @param {string} str The connection string URI
 */
function parseIrcUri(str) {
  let reg = /(?:(ircs?|wss?):\/\/)?([a-z.0-9-]+)(?::(?:(\+)?([0-9]+)))?(?:\/([^?]*))?(?:\?(.*))?/;
  let connections = [];
  str.split(';').forEach(connectionString => {
    if (!connectionString) {
      return;
    }
    let m = connectionString.match(reg);
    if (!m) {
      return;
    }
    let tls = m[1] === 'ircs' || m[1] === 'wss' || !!m[3];
    let direct = m[1] === 'ws' || m[1] === 'wss';
    let params = Object.create(null);
    (m[6] || '').split('&').forEach(p => {
      let parts = p.split('=');
      if (parts.length === 2) {
        params[parts[0].toLowerCase()] = parts[1];
      }
    });
    let channels = m[5] || params.channel || '';
    channels = (0, _lodash.default)(channels.split(',')).compact().map(_channelName => {
      let hasPrefix = _channelName[0] === '#' || _channelName[0] === '&';
      let channelName = hasPrefix ? _channelName : '#' + _channelName;
      return channelName;
    });
    connections.push({
      tls: tls,
      server: m[2],
      port: parseInt(m[4] || (tls ? 6697 : 6667), 10),
      channels: channels,
      nick: params.nick || '',
      encoding: params.encoding || 'utf8',
      params: params,
      direct: direct
    });
  });
  return connections;
}
function getDefaultConnection() {
  const connection = {
    name: '',
    server: '',
    port: 6667,
    tls: false,
    direct: false,
    path: '',
    type: 'irc',
    channels: ''
  };
  Object.defineProperty(connection, 'toUri', {
    value: () => connectionToUri(connection)
  });
  return connection;
}
const presetServerRegex = /^(?:(?<name>[^|\r\n]+)\|)?(?:(?<proto>(?:irc|ws)s?):\/\/)?(?<server>[^:/#?\r\n]+|(?:\[[^\]]+\]))(?::(?:(?<tls>\+)?(?<port>\d+)))?(?<path>\/([^#?\r\n])+)?(?<channels>[#&][^?\r\n]+)?(?:\?(?<params>.+))?$/;

/**
 * Parse preset server string to an object
 * format: freenode|irc.freenode.net:+6697
 * @param {string} input Preset server string
 */
function parsePresetServer(input) {
  const match = presetServerRegex.exec(input);
  if (!match || !match.groups) {
    return null;
  }
  const conn = getDefaultConnection();
  if (match.groups.tls === '+') {
    conn.tls = true;
  }
  if (match.groups.proto === 'ircs') {
    conn.port = 6697;
    conn.tls = true;
  } else if (match.groups.proto === 'ws') {
    conn.port = 8067;
    conn.direct = true;
  } else if (match.groups.proto === 'wss') {
    conn.port = 8097;
    conn.tls = true;
    conn.direct = true;
  }
  if (match.groups.port) {
    conn.port = parseInt(match.groups.port, 10);
  }
  if (match.groups.name) {
    conn.name = match.groups.name;
  } else {
    conn.name = match.groups.server;
  }
  if (match.groups.path) {
    conn.path = match.groups.path;
  }
  if (match.groups.params) {
    conn.params = new URLSearchParams(match.groups.params);
  }
  if (conn.params?.has('type')) {
    let type = conn.params.get('type');
    if (type === 'znc') {
      type = 'bnc';
    }
    if (['irc', 'bnc'].includes(type)) {
      conn.type = type;
    }
  }
  if (match.groups.channels) {
    conn.channels = conn.type === 'bnc' ? match.groups.channels.slice(1) : match.groups.channels;
  }
  conn.server = match.groups.server;
  return conn;
}
function connectionToUri(conn) {
  let proto = conn.direct ? 'ws' : 'irc';
  if (conn.tls) {
    proto += 's';
  }
  return `${proto}://${conn.server}:${conn.port}${conn.path}`;
}

/**
 * Scan though an object and extend any dot notated keys
 * @param {Object} confObj Source object to traverse
 */
function dedotObject(confObj) {
  if (_lodash.default.isArray(confObj)) {
    return;
  }
  _lodash.default.each(confObj, (val, key) => {
    if (typeof key === 'string' && key.includes('.')) {
      const path = key.split('.').filter(Boolean);
      if (path.length > 1) {
        delete confObj[key];
        _lodash.default.set(confObj, path, val);
        return;
      }
    }
    if (_lodash.default.isPlainObject(val)) {
      dedotObject(val);
    }
  });
}

/**
 * Replace the target object with source, while keeping the target object reference intact.
 * Delete all the properties from the target object and copy the properties from source
 * over to the target.
 * a = {one: 1, two: 2, three: 3}
 * b = {four: 4, five: 5, six: 6}
 * replaceObjectProps(a, b)
 * a.one === undefined;
 * a.six === 6;
 * @param {Object} target The target object that will be replaced
 * @param {Object} source The source object from which all properties will be copied from
 */
function replaceObjectProps(target, source) {
  Object.keys(target).forEach(prop => delete target[prop]);
  Object.keys(source).forEach(prop => {
    target[prop] = source[prop];
  });
}

/**
 * Create an ISO8601 formatted date
 * @param {Date} date The date object to create the time from. Defaults to the current time
 */
function dateIso(date) {
  let d = date || new Date();
  return strftimeUTC('%Y-%m-%dT%H:%M:%S.%LZ', d);
}

/**
 * Cast a string to an int, returning 0 if it fails
 * @param {String} inp The number as a string to convert to an int
 */
function parseIntZero(inp) {
  let int = parseInt(inp, 10);
  return Number.isNaN(int) ? 0 : int;
}

/**
 * Prepare plugin provided object, for use as a plugin component
 * @param {Number} pluginId The number to identify this plugin object
 * @param {Component} componentOrElement The vue.js component object or html element
 * @param {Object} args Optional arguments for this plugin { title: '', props: {} }
 */
function makePluginObject(pluginId, componentOrElement, args = {}) {
  const plugin = {
    id: pluginId,
    component: null,
    title: () => '',
    props: {},
    tabName: ''
  };

  // copy props from args
  plugin.props = Object.assign(plugin.props, args.props);
  plugin.tabName = args.tabName || args.title || 'plugin_tab_' + pluginId;
  if (componentOrElement instanceof Element) {
    // componentOrElement is an html element, so wrap it in a functional component

    // eslint-disable-next-line no-underscore-dangle
    if (componentOrElement.__vue__ && !window.app_deprecations_vueEl) {
      window.app_deprecations_vueEl = true;
      // eslint-disable-next-line no-console
      console.warn('deprecated component.$el added to plugin api, please switch to just passing the vue.js component object');
    }
    plugin.component = _PluginWrapper.default;
    plugin.props = Object.assign(plugin.props, {
      pluginElement: componentOrElement
    });
  } else if (componentOrElement instanceof Object) {
    // componentOrElement is an object, attempt to make a vue component from it
    plugin.component = _vue.default.extend(componentOrElement);
  } else {
    plugin.component = componentOrElement;
  }
  if (typeof args.title === 'string') {
    // if args.title exists wrap it in a function, that can also be a translation string
    plugin.title = () => args.title.slice(0, 2) === 't_' ? TextFormatting.t(args.title.slice(2)) : args.title;
  }
  return plugin;
}

/**
 * Check for trailing close bracket and return true if no matching open bracket is found
 * @param {String} str The string to check for trailing brackets
 * @returns {Boolean}  Boolean true when trailing bracket and no matching open bracket
 */
function hasUnmatchedTrailingBracket(str) {
  const brackets = [{
    o: '(',
    c: ')'
  }, {
    o: '[',
    c: ']'
  }, {
    o: '{',
    c: '}'
  }];
  const type = brackets.find(t => t.c === str[str.length - 1]);
  if (!type) {
    return false;
  }
  let unmatched = 0;
  for (let i = str.length - 1; i >= 0; i--) {
    if (str[i] === type.c) {
      unmatched++;
    } else if (str[i] === type.o) {
      unmatched--;
    }
  }
  return unmatched === 1;
}

// This provides a better sort for numbered nicks but does not work on ios9
let intlCollator;
if (global.Intl) {
  intlCollator = new Intl.Collator({}, {
    numeric: true
  });
}
function strCompare(a, b) {
  if (intlCollator) {
    return intlCollator.compare(a, b);
  }
  if (a === b) {
    return 0;
  }
  return a > b ? 1 : -1;
}
window._app_exports = window._app_exports || {};
if(!window._app_exports["helpers"]) window._app_exports["helpers"] = {};
window._app_exports["helpers"]["Misc"]
window._app_exports.helpers.Misc = exports.default ? exports.default : exports;
